import React from 'react';
import TailwindButtonDynamic from '../Layout/TailwindComponents/TailwindButtonDynamic';
import utils from '../../utils';
import LBSelect from '../DesignSystem/LBSelect/LBSelect';

function VPOProutineProgram({ yearsToShow, baselineData, handleRoutineOptimization, handleRoutineDelete, productOptions, scheduleOptions, optimizedDataRoutine }) {

    const programs = Array.isArray(optimizedDataRoutine) ? optimizedDataRoutine : (optimizedDataRoutine ? [optimizedDataRoutine] : []);
    const baseline = Array.isArray(baselineData) ? baselineData : (baselineData ? [baselineData] : []);
    const currentProduct = baseline[0]?.current_product ?? null;

    const removeBtnContent = {
        name: '',
        icon: utils.getIcon('xCircle', 'svg-12 m-i-start vertical-align'),
    }


    return (
        <div>
            {/* Baseline Routine Program */}
            <div className='p-06 bg-[var(--surface-secondary-light)] border border-[var(--border-secondary-light)] rounded-[var(--border-corner-radius-rounding-03)] mt-04 mb-04'>
                <label className='label-large block mb-04'>Baseline Routine Program</label>
                <label className='label-medium block mb-03'>Current Product</label>
                {currentProduct ? (
                    <input
                        disabled
                        value={currentProduct}
                        className='w-full p-02 border border-[var(--border-secondary-light)] rounded-[var(--border-corner-radius-rounding-02)] label-medium bg-[var(--surface-secondary-light)] text-[var(--text-primary-light)]'
                    />
                ) : (
                    <p className='label-small text-[var(--text-secondary-light)]'>No baseline program found.</p>
                )}
            </div>

            {/* Optimized Routine Program */}
            <div className='p-06 bg-[var(--surface-secondary-light)] border border-[var(--border-secondary-light)] rounded-[var(--border-corner-radius-rounding-03)] mt-04'>
                <label className='label-large block'>Optimized Routine Program</label>
                <label className='label-small block mb-04 text-[var(--text-secondary-light)]'>Edits here are reflected in the optimized budget outputs.</label>

                {programs.length > 1 && (
                    <p className='label-small text-[var(--text-error-light)] mb-03'>
                        Multiple programs found. Delete one to run scenario.
                    </p>
                )}

                {programs.map((program, index) => (
                    <div key={index} className="grid grid-cols-[1fr,1fr,1fr,48px] w-full gap-2 mb-4">
                        <div className="min-w-0">
                            <label className='label-medium block mb-03'>New program</label>
                            <LBSelect
                                disabled={false}
                                placeholder={program.product_characteristic?.product_characteristic_name ?? null}
                                value={program.product_characteristic?.product_characteristic_name ?? null}
                                options={productOptions}
                                onChange={(e) => handleRoutineOptimization(index, {product_characteristic: e})}
                                maxHeight='auto'
                                minHeight='auto'
                                size='small'
                                className="w-full"
                            />
                        </div>
                        <div className="min-w-0">
                            <label className='label-medium block mb-03'>Schedule</label>
                            <LBSelect
                                disabled={false}
                                value={program.schedule ?? null}
                                onChange={(e) => handleRoutineOptimization(index, {schedule: e})}
                                options={scheduleOptions}
                                maxHeight='auto'
                                minHeight='auto'
                                size='small'
                                className="w-full"
                            />
                        </div>
                        <div className="min-w-0">
                            <label className='label-medium block mb-03'>Year of Switch or Introduction</label>
                            <LBSelect
                                disabled={false}
                                value={program.intro_switch_year ?? null}
                                onChange={(e) => handleRoutineOptimization(index, {start_year: e})}
                                options={yearsToShow}
                                maxHeight='auto'
                                minHeight='auto'
                                size='small'
                                className="w-full"
                            />
                        </div>
                        <div>
                            <TailwindButtonDynamic
                                disabled={false}
                                actionHandler={() => handleRoutineDelete(index)}
                                content={removeBtnContent}
                                variant='tertiarySmallSurfaceBrandSecondary'
                                classSpecific={'!text-red-500 !border-transparent !bg-transparent hover:!bg-[var(--surface-error-light)] mt-06'}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default VPOProutineProgram;
